import React, { FC, Fragment, ReactElement, useState } from 'react';
import { Button, FormControl, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';

import { DatePickers } from 'components';

interface IProps {
  inputLabel: string | ReactElement;
  buttonLabel: string | ReactElement;
  value: number;
  onSave: (time: number) => void;
}

const useStyles = makeStyles(theme => ({
  button: {
    marginTop: theme.spacing(2),
    borderRadius: 4,
  },
}));

const Edit: FC<IProps> = ({ inputLabel, buttonLabel, value, onSave }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  function handleClose() {
    setAnchorEl(null);
  }

  function handleSave(time: number) {
    onSave(time);
    setAnchorEl(null);
  }

  return (
    <Fragment>
      <FormControl fullWidth margin="normal">
        <InputLabel shrink>{inputLabel}</InputLabel>
        <Button
          className={classes.button}
          variant="contained"
          onClick={event => setAnchorEl(event.currentTarget)}
          endIcon={<ArrowDropDown />}
        >
          {buttonLabel}
        </Button>
      </FormControl>
      <DatePickers.DateTime
        enableClear
        value={value}
        anchorEl={anchorEl}
        onClose={handleClose}
        onSave={handleSave}
      />
    </Fragment>
  );
};

export default Edit;
